import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'UPDATE_CONTRACTOR';

export async function updateContractor(
    userToken: string,
    updatedContractor: Record<string, unknown>,
    contractorId: number
) {
    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/contractors/${contractorId}/`,
            data: updatedContractor,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de modification du client.',
            error: error
        });
    }
}
